import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

function PieChart({data}) {
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  const options = {
    plugins: {
      tooltip: {
        titleFont: {
          family: "IRANSans",
          size: 10,
        },
        bodyFont: {
          family: "IRANSans",
          size: 10,
        },
        footerFont: {
          family: "IRANSans",
          size: 10,
        }
      },
      legend: {
        // rtl: true,
        labels: {
          font: {
            family: "IRANSans",
            size: 12,
          },
        },
      },
    },
  }

  // const data = {
  //   labels: ["تهران", "اصفهان", "فارس", "قم", "همدان", "یزد"],
  //   datasets: [
  //     {
  //       data: [12, 19, 3, 5, 2, 3],
  //       backgroundColor: [
  //         "#47cec0",
  //         "#4ec2e7",
  //         "#5c9def",
  //         "#9398ec",
  //         "#cb93ee",
  //         "#ec87bf",
  //       ],
  //
  //       borderWidth: 3,
  //     },
  //   ],
  // };

  return (
    <div className="p-3">
      <Pie
        data={data}
        options={options}
      />
    </div>
  );
}

export default PieChart;
